<template>
  <div class="ar-view">
    <div class="ar-source" ref="arSource" :style="videoStyle"></div>
    <canvas
      @mousedown="onMouseDown($event)"
      @mousemove="onMouseMove($event)"
      @mouseup="onMouseUp($event)"
      @touchstart="onMouseDown($event)"
      @touchmove.prevent="onMouseMove($event)"
      @touchend="onMouseUp($event)"
      class="three-canvas"
      ref="threeCanvas"
    ></canvas>
    <!-- <Stats /> -->
    <!-- <ControlKit :data.sync="controllableData" /> -->
  </div>
</template>

<script>
import Stats from '@/atoms/Stats'
// import ControlKit from '@/atoms/ControlKit'
import Viewport from '@/mixins/Viewport'
import Platform from '@/platform'
import HopeTotem from '@/atoms/HopeTotem'
// import FirePrerenderEvent from '@/mixins/FirePrerenderEvent'
import RAF from '@/utils/RAF'

/* global THREE */
// import 'three/OrbitControls'
window.THREE = THREE

/* global THREEx */
/* eslint-disable */
require('script-loader!jsartoolkit5/core')
require('script-loader!jsartoolkit5/api')
require('script-loader!threex/artoolkitsource')
require('script-loader!threex/artoolkitcontext')
THREEx.ArToolkitContext.baseURL = '/'
require('script-loader!threex/artoolkitprofile')
require('script-loader!threex/arbasecontrols')
require('script-loader!threex/armarkercontrols')
require('script-loader!threex/arsmoothedcontrols')
/* eslint-enable */

export default {
  name: 'TotemCanvasAR',

  mixins: [Viewport],

  components: {
    Stats
    // ControlKit
  },

  props: {
    totemData: {
      type: Object,
      required: false
    }
  },

  data: function () {
    return {
      totemDistanceFromCamera: 100,
      totemVisible: false,

      controllableData: {
        numTotems: {
          label: 'Totems',
          type: 'InputNumber',
          range: [1, 10],
          step: 1,
          value: 10,
          onUpdate: (value) => {
            this._totems.forEach((totem, index) => {
              if (index < value) {
                totem.visible = true
              } else {
                totem.visible = false
              }
            })
          }
        },
        shadowEnabled: {
          label: 'Shadows',
          type: 'Checkbox',
          value: false,
          onUpdate: (value) => {
            this._renderer.shadowMap.enabled = value
            this.shadowPlane.visible = value
          }
        },
        shadowType: {
          label: 'Shadow Quality',
          type: 'Select',
          value: THREE.PCFSoftShadowMap,
          choices: [{
            label: 'BasicShadowMap',
            value: THREE.BasicShadowMap
          }, {
            label: 'PCFShadowMap',
            value: THREE.PCFShadowMap
          }, {
            label: 'PCFSoftShadowMap',
            value: THREE.PCFSoftShadowMap
          }],
          onUpdate: (value) => {
            this._renderer.shadowMap.type = value
            this.shadowPlane.material.needsUpdate = true
          }
        },
        debug: {
          label: 'Debug Collisions',
          type: 'Checkbox',
          value: false,
          onUpdate: (value) => {
            this._totems.forEach((totem) => {
              totem.debug = value
            })
          }
        },
        collisionLOD: {
          label: 'Collisions LOD Level',
          type: 'InputNumber',
          range: [0, 2],
          step: 1,
          value: 0,
          onUpdate: (value) => {
            this._totems.forEach((totem) => {
              totem.collisionLOD = value
            })
          }
        },
        rotate: {
          label: 'Rotate Stones',
          type: 'Checkbox',
          value: true,
          onUpdate: (value) => {
            this._totems.forEach((totem) => {
              totem.rotate = value
            })
          }
        },
        oscillate: {
          label: 'Oscillate Stones',
          type: 'Checkbox',
          value: false,
          onUpdate: (value) => {
            this._totems.forEach((totem) => {
              totem.oscillate = value
            })
          }
        }
      }
    }
  },

  mounted: function () {
    if (!Platform.prerenderer) {
      this._renderer = new THREE.WebGLRenderer({
        antialias: true,
        canvas: this.$refs.threeCanvas,
        alpha: true
      })

      this._clock = new THREE.Clock()
      this._renderer.toneMapping = THREE.LinearToneMapping
      this._renderer.setClearColor(0xffffff, 0)
      // this._renderer.setPixelRatio(window.devicePixelRatio)
      this._renderer.setSize(this.viewPort.width, this.viewPort.height)
      this._renderer.shadowMap.enabled = this.controllableData.shadowEnabled
      this._renderer.shadowMap.type = THREE.PCFSoftShadowMap
      /*
      this._camera = new THREE.PerspectiveCamera(50, this.viewPort.width / this.viewPort.height, 1, 25000)
      this._camera.position.z = 15
      this._camera.position.y = 3
      */
      this._camera = new THREE.Camera()

      this._scene = new THREE.Scene()

      this._totems = []

      let materials = []
      for (let i = 0; i < 10; i++) {
        materials.push(new THREE.MeshToonMaterial({
          color: Math.random() * 0xffffff,
          specular: new THREE.Color(0x000000),
          shininess: 0
        }))
      }
      /*
      for (let i = 0; i < this.controllableData.numTotems.range[1]; i++) {
        // let totem = new HopeTotem(2 + Math.ceil(Math.random() * 8))
        let totem = new HopeTotem(10, materials)
        totem.position.x = THREE.Math.randFloatSpread(10)
        totem.position.z = THREE.Math.randFloatSpread(10)
        this._scene.add(totem)
        this._totems.push(totem)
        totem.visible = false
      }
      */
      this.shadowPlane = new THREE.Mesh(new THREE.PlaneGeometry(100, 100), new THREE.ShadowMaterial({opacity: 0.2}))
      this.shadowPlane.rotation.x = -Math.PI / 2
      // this.shadowPlane.position.y = -0.5
      this.shadowPlane.receiveShadow = true
      this._scene.add(this.shadowPlane)

      this.light = new THREE.DirectionalLight()
      this.light.castShadow = true
      this.light.shadow.mapSize.width = 512
      this.light.shadow.mapSize.height = 512
      this.light.shadow.camera.far = 1000
      this.light.shadow.camera.left = -6
      this.light.shadow.camera.right = 6
      this.light.shadow.camera.top = 6
      this.light.shadow.camera.bottom = -6
      this.light.position.set(-30, 30, 30)

      this._scene.add(this.light)
      /*
      this._controls = new THREE.OrbitControls(this._camera)
      this._controls.target.set(0, this._camera.position.y, 0)
      */
      for (let val in this.controllableData) {
        this.controllableData[val].onUpdate(this.controllableData[val].value)
      }

      /// /////////////////////////////////////////////////////////////////////////////
      //          initialize arToolkit
      /// /////////////////////////////////////////////////////////////////////////////

      this._arToolkitSource = new THREEx.ArToolkitSource({
        sourceType: 'webcam'

        // to read from an image
        // sourceType : 'image',
        // sourceUrl : THREEx.ArToolkitContext.baseURL + '../data/images/img.jpg',
        // sourceUrl : THREEx.ArToolkitContext.baseURL + '../data/images/armchair.jpg',

        // to read from a video
        // sourceType : 'video',
        // sourceUrl : THREEx.ArToolkitContext.baseURL + '../data/videos/headtracking.mp4',
      })
      this._arToolkitSource.init(() => {
        this.onResize()
        this._arToolkitSource.domElement.style.zIndex = 0
        this.$refs.arSource.appendChild(this._arToolkitSource.domElement)
        this._arToolkitSource.domElement.play()
      })

      // create atToolkitContext
      this._arToolkitContext = new THREEx.ArToolkitContext({
        cameraParametersUrl: THREEx.ArToolkitContext.baseURL + 'static/data/camera_para.dat',
        // debug: true,
        // detectionMode: 'mono_and_matrix',
        detectionMode: 'mono',
        // detectionMode: 'color_and_matrix',
        // matrixCodeType: '3x3',

        canvasWidth: 80 * 3,
        canvasHeight: 60 * 3,

        maxDetectionRate: 30
      })
      // initialize it
      this._arToolkitContext.init(() => {
        // copy projection matrix to camera
        this._camera.projectionMatrix.copy(this._arToolkitContext.getProjectionMatrix())
      })

      this._markerRoot = new THREE.Group()
      this._scene.add(this._markerRoot)
      this._markerControls = new THREEx.ArMarkerControls(this._arToolkitContext, this._markerRoot, {
        // type: 'barcode',
        // barcodeValue: 5,

        type: 'pattern',
        // patternUrl: THREEx.ArToolkitContext.baseURL + 'static/data/barno-marker.patt'
        patternUrl: THREEx.ArToolkitContext.baseURL + 'static/data/pattern-marker.patt'
        // https://jeromeetienne.github.io/AR.js/three.js/examples/marker-training/examples/generator.html
        // for creating custom markers
      })

      // build a smoothedControls
      var smoothedRoot = new THREE.Group()
      this._scene.add(smoothedRoot)
      this._smoothedControls = new THREEx.ArSmoothedControls(smoothedRoot, {
        lerpPosition: 0.4,
        lerpQuaternion: 0.3,
        lerpScale: 1
        // minVisibleDelay: 1,
        // minUnvisibleDelay: 1,
      })

      let userTotemData = this.totemData
      if (!userTotemData) {
        // create a testing totem
        userTotemData = {
          id: 'ar-totem',
          position: {x: 0, z: 0},
          stones: []
        }
        for (var i = 0; i < 6; i++) {
          let stoneData = {
            averageActivity: Math.random(),
            color: Math.random() * 0xffffff,
            concepts: []
          }
          for (var k = 0; k < Math.ceil(Math.random() * 4); k++) {
            stoneData.concepts.push({
              activity: Math.random(),
              category: i,
              id: k,
              importance: 0,
              label: 'test'
            })
          }
          userTotemData.stones.push(stoneData)
        }
      }

      let totem = new HopeTotem(userTotemData, true)
      totem.scale.set(0.4, 0.4, 0.4)
      this._totems.push(totem)
      smoothedRoot.add(totem)
      smoothedRoot.add(this.light)
      smoothedRoot.add(this.shadowPlane)
      /*
      var geometry = new THREE.CubeGeometry(1, 1, 1)
      var material = new THREE.MeshNormalMaterial({
        transparent: true,
        opacity: 0.5,
        side: THREE.DoubleSide
      })
      var mesh = new THREE.Mesh(geometry, material)
      mesh.position.y = geometry.parameters.height / 2
      smoothedRoot.add(mesh)
      */
      RAF.add(this.render)
    }
  },

  beforeDestroy: function () {
    if (this._arToolkitSource.domElement.srcObject) {
      this._arToolkitSource.domElement.srcObject.getTracks().forEach(track => track.stop())
    }
    this._scene.traverse(this.destroySceneChildren)
    this._renderer.dispose()
    this._renderer.forceContextLoss()
    RAF.remove(this.render)
  },
  computed: {
    videoStyle: function () {
      // distance : 8 = x :
      // let distanceBlurAmount = Math.max(0, 8 - this.totemDistanceFromCamera) * 1.5
      // let blurAmount = this.totemVisible ? distanceBlurAmount : 0
      return {
        // filter: `grayscale(100%) contrast(110%) blur(${blurAmount}px)`
        filter: `grayscale(100%) contrast(110%)`
      }
    }
  },

  methods: {
    destroySceneChildren: function (value) {
      if (typeof value.destroy === 'function') {
        value.destroy()
      } else {
        if (value.geometry) {
          value.geometry.dispose()
        }
        if (value.material) {
          if (value.material.map) {
            value.material.map.dispose()
          }
          value.material.dispose()
        }
      }
    },
    render: function () {
      let delta = this._clock.getDelta()
      this._renderer.render(this._scene, this._camera)

      // console.log(new Date().getTime())

      if (this._totems) {
        for (let i = 0; i < this._totems.length; i++) {
          if (this._totems[i].visible) {
            this._totems[i].update(delta)
          }
        }
      }

      if (this._arToolkitSource.ready) {
        this._arToolkitContext.update(this._arToolkitSource.domElement)
      }
      this._smoothedControls.update(this._markerRoot)

      this.totemVisible = this._markerRoot.visible
      this.totemDistanceFromCamera = this._markerRoot.position.distanceTo(this._camera.position)
      // console.log(this._markerRoot.visible, this._markerRoot.position.distanceTo(this._camera.position))
    },
    onMouseDown: function (event) {

    },
    onMouseUp: function (event) {

    },
    onMouseMove: function (event) {

    },
    onResize: function () {
      if (this._renderer) {
      //   this._renderer.setPixelRatio(window.devicePixelRatio)
        this._renderer.setSize(this.viewPort.width, this.viewPort.height)
      }

      // if (this._camera) {
      //   this._camera.aspect = this.viewPort.width / this.viewPort.height
      //   this._camera.updateProjectionMatrix()
      // }

      this._arToolkitSource.onResizeElement()
      this._arToolkitSource.copyElementSizeTo(this._renderer.domElement)
      if (this._arToolkitContext.arController !== null) {
        this._arToolkitSource.copyElementSizeTo(this._arToolkitContext.arController.canvas)
      }
      this._camera.projectionMatrix.copy(this._arToolkitContext.getProjectionMatrix())
    }
  },

  watch: {
    viewPort: function () {
      this.onResize()
    }
  },

  metaInfo: function () {
    return {
      // home page browser title
      title: 'Home Page'
    }
  }
}
</script>

<style scoped lang="scss">

@import 'sprite';
@import 'mixins';

.three-canvas {
  position: absolute;
  top: 0;
  left: 0;
}

.ar-view {
  width: 100%;
}

.ar-source {
  transition: filter 1s;
}

</style>



// WEBPACK FOOTER //
// src/molecules/TotemCanvasAR.vue